module.exports = __webpack_public_path__ + "static/media/icomoon.f08c9200.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/icons/icomoon/fonts/icomoon.woff?q6x2r9
// module id = 2324
// module chunks = 19